import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/w/modules')({
  staticData: { breadcrumb: 'Module Registry', breadcrumbKey: 'K_MODULE_REGISTRY' },
  component: ModulesLayout,
});

function ModulesLayout() {
  return <Outlet />;
}
